import { Link, useLocation } from 'react-router-dom';
import { useT } from '../i18n/i18n';
import { useTrial } from './trial';

export default function TrialBanner() {
  const t = useT();
  const { trial } = useTrial();
  const { pathname } = useLocation();
  if (!trial?.limited || pathname.startsWith('/play/') || pathname.startsWith('/account/subscription') || pathname.startsWith('/subscribe')) return null;
  return (
    <div className="trial-banner" role="note">
      <span>{t('You are on the limited trial, with a few programs to try.')}</span>
      <Link className="btn secondary" to="/account/subscription">{t('Start your full 7-day trial')}</Link>
    </div>
  );
}
